import { Component, ChangeDetectionStrategy, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { LanguageService } from '@fcom/ui-translate';

import { consentPreferencesToken } from './marketing-preferences-utils';

@Component({
  selector: 'fin-marketing-preferences-page',
  template: ` <div class="grid-col-12 grid-max-width no-row-gap">
    <div class="col-1-12 sm-col-2-11 md-col-3-10 xl-col-4-9 center mr-large-y">
      <fin-marketing-preferences [useModal]="false"></fin-marketing-preferences>
    </div>
  </div>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MarketingPreferencesPageComponent implements OnInit {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private languageService = inject(LanguageService);

  ngOnInit(): void {
    const token = this.route.snapshot.queryParamMap.get(consentPreferencesToken);

    if (!token) {
      this.router.navigate([`/${this.languageService.langValue}`], {
        replaceUrl: true,
      });
    } else {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {
          [consentPreferencesToken]: null,
        },
        queryParamsHandling: 'merge',
      });
    }
  }
}
